import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index.vue'
import insurancePlan from '../views/insurancePlan.vue'
import internet from '../views/internet.vue'
import medical from '../views/medical.vue'
import about from '../views/about.vue'
import contactus from '../views/contactus.vue'
import VueRouter from 'vue-router'
import drug from '../views/drug.vue'
import drugDetail from '../views/drugDetail.vue'
import medicalDevices from '../views/medicalDevices.vue'
import medicalDevicesVoucher from '../views/medicalDevicesVoucher.vue'
import YJExperience from '../views/YJExperience.vue'
import news from '../views/news.vue'
import product from '../views/product.vue'
import drugDevices from '../views/drugDevices.vue'
import internetFood from '../views/internetFood.vue'
import yywy from '../views/yywy.vue'
import yjey from '../views/yjey.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title: '优加健保健康科技 ( 北京 ) 有限公司'
    }
  },
  {
    path:'index',
    name:'index',
    component: index,
    meta: {
      title: '优加健保健康科技 ( 北京 ) 有限公司'
    }
  },
  {
    path:'/insurancePlan',
    name: 'insurancePlan',
    component: insurancePlan,
    meta: {
      title:'保险端解决方案'
    }
  },
  {
    path: '/internet',
    name: 'internet',
    component: internet,
    meta: {
      title: '互联网平台合作'
    }
  },
  {
    path: '/medical',
    name: 'medical',
    component: medical,
    meta:{
      title: '医疗供给端'
    }
  },
  {
    path: '/drug',
    name: 'drug',
    component: drug,
    meta:{
      title: '药品信息'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: about,
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: contactus,
    meta: {
      title: '加入我们'
    }
  },{
    path: '/drugDetail',
    name: 'drugDetail',
    component: drugDetail,
    meta:{
      title: '药品信息详情'
    }
  },{
    path: '/medicalDevices',
    name: 'medicalDevices',
    component: medicalDevices,
    meta: {
      title: '药品医疗器械网络信息服务备案'
    }
  },{
    path: '/medicalDevicesVoucher',
    name: 'medicalDevicesVoucher',
    component: medicalDevicesVoucher,
    meta: {
      title: '医疗器械网络交易服务第三方平台备案凭证'
    }
  },{
    path: '/YJExperience',
    name: 'YJExperience',
    component:YJExperience,
    meta: {
      title:'优加体验'
    }
  },{
    path: '/news',
    name: 'news',
    component:news,
    meta: {
      title: '新闻动态'
    }
  },
  {
    path: '/product',
    name: 'product',
    component: product,
    meta: {
      title: '产品矩阵'
    }
  }, {
    path: '/drugDevices',
    name: 'drugDevices',
    component: drugDevices,
    meta: {
      title: '药品网络交易服务第三方平台备案 '
    }
  },{
    path: '/internetFood',
    name: 'internetFood',
    component: internetFood,
    meta: {
      title: '网络食品交易第三方平台提供者备案信息表 '
    }
  }, {
    path: '/yywy',
    name: 'yywy',
    component: yywy,
    meta: {
      title: '颐养无忧'
    }
  }, {
    path: '/yjey',
    name: 'yjey',
    component: yjey,
    meta: {
      title: '优加儿依'
    }
  }
]

// export default new Router({
  
// })

const router = new VueRouter({
  // mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0}
  }
})


router.beforeEach((to,from,next) => {
  if(to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '优加健保健康科技 ( 北京 ) 有限公司'
  }
  next()
})

export default router 



// WEBPACK FOOTER //
// ./src/router/index.js